import React from "react";
import Style from "./Blog.module.scss";
import classNames from "classnames";
import {
    BrowserRouter as Router,
    useLocation
  } from "react-router-dom"

import { info, colors } from "../Info/Info";

export default function Blog() {
    const location = useLocation()
    const queryParameters = new URLSearchParams(location.search)

    let title = queryParameters.get("title");
    let portfolioInfo = info.portfolio;


    function createBlog() {
        
        let results = [];
        let j = 0;

        for (let i = 0; i < portfolioInfo.length; i++) { 

            if(info.portfolio[i].title == title) {
                results.push(
                    <div>
                        <h1>
                        {title}
                        </h1>
                    
                        <div className={Style.block}>
                            <img
                            className={Style.image}
                            src={info.portfolio[i].image}
                            />
                        </div>

                        <p>
                            {info.portfolio[i].theStory}
                        </p>
                    </div>
                    
                )
                return results;
            }
        }
    }
   
  return (
    <main>
        <div className={Style.projectsGrid}>{createBlog()}</div>
    </main>
  );
}
